// extracted by mini-css-extract-plugin
export default {"input":"MakeBet_input__AEH6c","error":"MakeBet_error__teq5W"};